import {
  FilterValue,
  SelectFilter,
  SelectOption,
  StringFilterValue,
} from "../../types/filter";
import {
  getSelectedFilterValue,
  updatedFilterValueFromValues,
} from "../../utils/filter/filtervalue";
import { createFilterValueFromSelectOption } from "../../utils/filter/selectfiltervalue";
import { SelectListView } from "../SelectListView/SelectListView";

interface FilterTabSelectProps {
  filter: SelectFilter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
}

export const FilterTabSelect = ({
  filter,
  filterValues,
  setFilterValues,
}: FilterTabSelectProps) => {
  const { id, defaultValue } = filter;
  const selected = getSelectedFilterValue(
    id,
    filterValues,
    defaultValue
  ) as StringFilterValue;
  const handleOnChange = (option: SelectOption) => {
    const value = createFilterValueFromSelectOption(id, option);
    setFilterValues(updatedFilterValueFromValues(filterValues, filter, value));
  };
  return (
    <SelectListView
      prefix="pill"
      filter={filter}
      selected={selected}
      onChange={handleOnChange}
    />
  );
};
